// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".steps-line:before{content:\"\";width:100%;position:absolute;top:0;right:0;left:0;height:1px;margin-top:4rem;margin-left:auto;background-color:rgba(2,1,1,.0784313725490196)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
